import { initializeApp } from "@firebase/app";
import { getStorage } from "@firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBRhDi-nEk31QLWz0E78gSQadyBoUkRdB8",
  authDomain: "design-guild-frontend2.firebaseapp.com",
  projectId: "design-guild-frontend2",
  storageBucket: "design-guild-frontend2.firebasestorage.app",
  messagingSenderId: "775451072301",
  appId: "1:775451072301:web:4d7fed1b10adab39cae5a4",
  measurementId: "G-PLVK56SBX0",
};

export const firebaseApp = initializeApp(firebaseConfig);

export const imageDb = getStorage(firebaseApp);

export enum FirebasePaths {
  DEFAULT = "uploaded-content-fallback",
  PROJECT_FILES = "design-files/project-files",
  BEFORE_AND_AFTER = "design-files/before-and-after",
  DESIGN_BOARD = "design-files/design-board",
  IDEA_BOOKS = "idea-books",
  BIO_IMAGE = "designer-bio-image",
  HOMEOWNER_PROFILE_IMAGE = "homeowner-profile-image",
  MESSAGES = "messages",
}

export const getFirebaseStoragePath = (userId: string, path: FirebasePaths) => {
  return `${userId}/${path}`;
};
